import { render, staticRenderFns } from "./eg_button.vue?vue&type=template&id=9397b274&scoped=true&"
import script from "./eg_button.vue?vue&type=script&lang=js&"
export * from "./eg_button.vue?vue&type=script&lang=js&"
import style0 from "./eg_button.vue?vue&type=style&index=0&id=9397b274&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9397b274",
  null
  
)

export default component.exports